"use client";

import { useState } from "react";

function toAbsolute(url: string) {
  if (url.startsWith("http")) return url;
  if (typeof window === "undefined") return url;
  return `${window.location.origin}${url.startsWith("/") ? url : `/${url}`}`;
}

export function PolicyShareButton({
  url,
  title,
}: {
  url: string;
  title: string;
}) {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  async function shareNative() {
    const absolute = toAbsolute(url);
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, url: absolute, text: title });
        return;
      } catch {
        // Fall through to menu if user cancels or share fails.
      }
    }
    setOpen((v) => !v);
  }

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(toAbsolute(url));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  const absolute = typeof window !== "undefined" ? toAbsolute(url) : url;
  const encoded = encodeURIComponent(absolute);
  const text = encodeURIComponent(title);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => void shareNative()}
        className="text-[var(--accent)] underline-offset-2 hover:underline"
      >
        Share
      </button>
      {open ? (
        <div className="absolute right-0 z-20 mt-2 min-w-[180px] rounded border border-[var(--border-subtle)] bg-[var(--surface)] p-2 shadow-lg">
          <button
            type="button"
            onClick={() => void copyLink()}
            className="block w-full rounded px-2 py-1.5 text-left text-sm hover:bg-[color-mix(in_srgb,var(--accent)_12%,transparent)]"
          >
            {copied ? "Copied" : "Copy link"}
          </button>
          <a
            href={`https://wa.me/?text=${text}%20${encoded}`}
            target="_blank"
            rel="noreferrer"
            className="block rounded px-2 py-1.5 text-sm text-[var(--foreground)] no-underline hover:bg-[color-mix(in_srgb,var(--accent)_12%,transparent)]"
          >
            WhatsApp
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${encoded}&text=${text}`}
            target="_blank"
            rel="noreferrer"
            className="block rounded px-2 py-1.5 text-sm text-[var(--foreground)] no-underline hover:bg-[color-mix(in_srgb,var(--accent)_12%,transparent)]"
          >
            X
          </a>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encoded}`}
            target="_blank"
            rel="noreferrer"
            className="block rounded px-2 py-1.5 text-sm text-[var(--foreground)] no-underline hover:bg-[color-mix(in_srgb,var(--accent)_12%,transparent)]"
          >
            Facebook
          </a>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`}
            target="_blank"
            rel="noreferrer"
            className="block rounded px-2 py-1.5 text-sm text-[var(--foreground)] no-underline hover:bg-[color-mix(in_srgb,var(--accent)_12%,transparent)]"
          >
            LinkedIn
          </a>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="mt-1 block w-full rounded px-2 py-1 text-left text-[11px] text-[var(--muted)]"
          >
            Close
          </button>
        </div>
      ) : null}
    </div>
  );
}
